/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Careers_Pay_RangeInputs */



/**
* | output |
* | --- |
* | "{min} to {max}" |
*
* @param {Careers_Pay_RangeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const careers_pay_range = /** @type {((inputs: Careers_Pay_RangeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Pay_RangeInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`${i?.min} 至 ${i?.max}`)
	return /** @type {LocalizedString} */ (`${i?.min} to ${i?.max}`)
});